import script from "./TagsDropdownContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagsDropdownContent.vue?vue&type=script&lang=ts&setup=true"

import "./TagsDropdownContent.vue?vue&type=style&index=0&id=2e25714f&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e25714f"]])

export default __exports__